var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"text-gray-800 dark:text-gray-100 font-semibold text-lg mb-1.5"},[_vm._v(" "+_vm._s(_vm.author.name)+" "+_vm._s(_vm.author.lastname)+" "),_c('span',{staticClass:"text-gray-400"},[_vm._v(_vm._s(_vm.author.email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }